import * as Yup from 'yup';
import checkIsRequireTargetPort from '../helpers/checkIsRequireTargetPort';

const dockerImageNameRegex = /^([a-z0-9]+(?:[._-][a-z0-9]+)*)$/;
const branchNameRegex = /^(?!.*[ ]).+(?![./])[^~^:?*[\]]*$/;
const repositoryUrlRegex =
  /^(https?:\/\/)?([a-zA-Z0-9._~:@%-]+@)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/[^\s]*)?$/;
const dockerfilePathRegex =
  /^[a-zA-Z0-9._-]+(?:[\\/][a-zA-Z0-9._-]+)*[\\/]dockerfile$/i;
export default Yup.object().shape({
  BranchName: Yup.string()
    .matches(branchNameRegex, 'Branch Name is invalid')
    .test(
      'not-main-branch',
      'Branch name "main" is not allowed. Please use "master" instead.',
      function (value) {
        return value?.toLowerCase() !== 'main';
      }
    )
    .max(255)
    .required()
    .label('Branch Name'),
  RepositoryUrl: Yup.string()
    .matches(repositoryUrlRegex, 'Repository URL is invalid')
    .max(255)
    .required()
    .label('Repository Url'),
  DockerfilePath: Yup.string()
    .test(
      'valid-dockerfile-path',
      'Dockerfile Path is invalid',
      function (value) {
        return !(
          value?.toLowerCase() !== 'dockerfile' &&
          !dockerfilePathRegex.test(value)
        );
      },
    )
    .label('Dockerfile Path'),
  RootFolderPath: Yup.string().nullable().label('Root folder path'),
  AccessToken: Yup.string().max(255).required().label('Access Token'),
  ImageName: Yup.string()
    .matches(dockerImageNameRegex, 'Image Name is invalid')
    .max(32)
    .required()
    .label('Image Name'),
  DeploymentType: Yup.object().nullable().required().label('Deployment Type'),
  TargetPort: Yup.string()
    .when('DeploymentType', {
      is: (val) => checkIsRequireTargetPort(val),
      then: Yup.string().required(),
      otherwise: Yup.string(),
    })
    .label('Target Port'),
  ShowPassword: Yup.boolean(),
  AppModel: Yup.object().nullable().required().label('Marketplace App'),
});
